import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_CURRENCIES'),
  ...asyncTypes('CREATE_CURRENCIES')
};

export default TYPES;
